import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { BellRing, X } from "lucide-react";

export function QuotaReminder() {
  const navigate = useNavigate();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const { data } = useQuery({
    queryKey: ["quota-status"],
    queryFn: async () => (await api.get("/payments/quota-status")).data,
  });

  if (dismissed || !data?.reminder_active) return null;

  return (
    <div data-testid="quota-reminder-banner" className="mb-5 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3">
      <div className="flex items-start gap-3">
        <BellRing className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#D97706]" />
        <div>
          <p className="text-sm font-bold text-amber-900">Rinnovo quota associativa {data.year}</p>
          <p className="text-sm text-amber-800">
            È il momento di rinnovare la quota associativa di € {Number(data.amount).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. Promemoria attivo dal 10 gennaio.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {location.pathname !== "/pagamenti" && (
          <Button size="sm" className="bg-[#D97706] hover:bg-[#b45309]" data-testid="quota-reminder-pay" onClick={() => navigate("/pagamenti")}>
            Paga ora
          </Button>
        )}
        <Button size="sm" variant="ghost" className="text-amber-700 hover:bg-amber-100" data-testid="quota-reminder-dismiss" onClick={() => setDismissed(true)}>
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
